import { Tag, Text } from '@spotify-internal/encore-web';
import { extractLastNameComponent } from '@spotify/confidence-core-react';
import { isType } from '@spotify/confidence-graphql';
import { useSetResolvedTitle } from '@spotify/plugin-confidence-projects-react';
import { useSegment } from '@spotify/plugin-confidence-targeting-react';

import {
  AudienceSummary,
  KeyValueRow,
  PreviewShell,
  SummarySection,
  TypeStatusRow,
  resolveDisplayName,
} from './components';

interface SegmentArtifactPreviewProps {
  resourceName: string;
  label: string;
}

export const SegmentArtifactPreview = ({
  resourceName,
  label,
}: SegmentArtifactPreviewProps) => {
  const { segment, isLoading, error } = useSegment({ name: resourceName });

  const linkedFlag = isType(segment?.flag, 'FlagsAdminV1Flag')
    ? segment.flag
    : undefined;
  const previewError =
    error ?? (!isLoading && !segment ? 'not-found' : undefined);

  useSetResolvedTitle(
    segment?.displayName || extractLastNameComponent(resourceName),
  );

  const criteriaCount = segment?.targeting?.criteria?.length ?? 0;

  return (
    <PreviewShell loading={isLoading} error={previewError}>
      {segment && (
        <>
          <TypeStatusRow
            typeLabel={label}
            state={segment.state ?? undefined}
            demoLabels={segment.labels}
          />
          {segment.description && (
            <Text variant="bodySmall" semanticColor="textSubdued">
              {segment.description}
            </Text>
          )}
          <SummarySection title="Audience">
            <AudienceSummary
              allocationProportion={segment.allocation?.proportion?.value}
              criteriaCount={criteriaCount}
            />
          </SummarySection>
          {linkedFlag && (
            <SummarySection title="References">
              <KeyValueRow label="Flag">
                <Tag>{resolveDisplayName(linkedFlag)}</Tag>
              </KeyValueRow>
            </SummarySection>
          )}
        </>
      )}
    </PreviewShell>
  );
};
